module.exports = __webpack_public_path__ + "img/reward-5.3d798871.svg";